// /* can be used to remove the opening and closing <svg> tag from an svg image.
// returns a match with the following result:
// res[0] = complete SVG code stripped from xml declarations
// res[1] = opening SVG Tag <svg...>
// res[2] = "inner svg" content of SVG
// res[3] = closing svg tag </svg>
// const SVG_REPLACE_REGEXP = /(?:<svg[^>]*>)([^]*)(?:<\/svg>)/m;
import {
	DATAPOINT_BUTTON_COLOR1,
	DATAPOINT_BUTTON_COLOR2,
	DATAPOINT_BUTTON_FREQUENCY1,
	DATAPOINT_BUTTON_FREQUENCY2,
	DATAPOINT_IS_ONLINE,
	DATAPOINT_LED_COLOR,
	DATAPOINT_LED_FREQUENCY,
	DATAPOINT_PIN1_STATUS,
	DATAPOINT_PIN2_STATUS,
	DATAPOINT_PIN3_STATUS,
	DATAPOINT_PIN4_STATUS,
	DATAPOINT_PIN1_MODE,
	DATAPOINT_PIN2_MODE,
	DATAPOINT_PIN3_MODE,
	DATAPOINT_PIN4_MODE,
	SBOX_TYPE,
	SLIGHT_TYPE,
	KISIO_TYPE
} from '../../../../modules/common/consts';
const SVG_STRIP_REGEXP = /(<svg[^>]*>)([^]*)(<\/svg>)/m;
const RGB_COLOR_REGEXP = /[0-9]{1,3}/gm;
const ELEMENT_CLASSNAME = 'added-element';
const INTERACTIVE_ELEMENT_CLASSNAME = 'added-interactive-element';
const DISPLAY_ELEMENT_CLASSNAME = 'added-display-element';
const DATAPOINTS_GPIO = [
	DATAPOINT_PIN1_STATUS,
	DATAPOINT_PIN2_STATUS,
	DATAPOINT_PIN3_STATUS,
	DATAPOINT_PIN4_STATUS,
	DATAPOINT_PIN1_MODE,
	DATAPOINT_PIN2_MODE,
	DATAPOINT_PIN3_MODE,
	DATAPOINT_PIN4_MODE
];
const LED_SELECTORS: Record<string, string> = {
	[DATAPOINT_LED_COLOR]: 'g#di-sLight-color',
	[DATAPOINT_BUTTON_COLOR1]: 'g#di-button-1',
	[DATAPOINT_BUTTON_COLOR2]: 'g#di-button-2',
	[DATAPOINT_IS_ONLINE]: 'g#di-online-indicator'
};
const DATAPOINTS_BY_TYPE: Record<string, string[]> = {
	[SBOX_TYPE]: [
		DATAPOINT_BUTTON_COLOR1,
		DATAPOINT_BUTTON_COLOR2,
		DATAPOINT_IS_ONLINE,
		DATAPOINT_BUTTON_FREQUENCY1,
		DATAPOINT_BUTTON_FREQUENCY2,
		...DATAPOINTS_GPIO
	],
	[SLIGHT_TYPE]: [DATAPOINT_IS_ONLINE, DATAPOINT_LED_COLOR, DATAPOINT_LED_FREQUENCY, ...DATAPOINTS_GPIO],
	[KISIO_TYPE]: [DATAPOINT_IS_ONLINE, ...DATAPOINTS_GPIO]
};
const COLORS = {
	RED: '#ff0000',
	GREEN: '#00cc00'
};
const MAX_SIZE_IN_MB = 5;
const MAX_SIZE = MAX_SIZE_IN_MB * 1024 * 1024;
const SVG_MIME_TYPE = 'image/svg+xml';
export {
	MAX_SIZE,
	MAX_SIZE_IN_MB,
	SVG_MIME_TYPE,
	COLORS,
	LED_SELECTORS,
	ELEMENT_CLASSNAME,
	DISPLAY_ELEMENT_CLASSNAME,
	INTERACTIVE_ELEMENT_CLASSNAME,
	SVG_STRIP_REGEXP,
	DATAPOINTS_BY_TYPE,
	RGB_COLOR_REGEXP
};
